import React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import ETLogo from '../../assets/images/elegant_tex_logo.jpg';
import { addressLines, contactLines, logoSrc, withFallback } from '../../utils/company';

/**
 * The "who is sending you this" block at the top left of an invoice: logo,
 * name, address, phone, email.
 *
 * Its own component because two documents print it and they must not disagree —
 * which they did, as two copies of the same literals, until the company profile
 * replaced them. Everything here is driven by the profile; nothing is fixed
 * except the logo's last-resort fallback.
 *
 * `styles` comes from the calling document, so each invoice keeps its own type
 * scale rather than this component imposing one.
 */
const InvoiceSellerBlock = ({ company, styles }) => {
  const profile = withFallback(company);
  const lines = [...addressLines(profile), ...contactLines(profile)];

  // The uploaded logo when there is one, otherwise the bundled mark. Falling
  // back keeps every existing install's invoices looking exactly as they did
  // the day this shipped — none of them has uploaded a logo yet.
  const logo = logoSrc(profile) || ETLogo;

  return (
    <View style={{ flexDirection: 'row', flex: 1 }}>
      <Image src={logo} style={styles.logo} />
      <View style={{ paddingTop: 2, flex: 1 }}>
        <Text style={styles.brandName}>{profile.name}</Text>
        {profile.tagline ? <Text style={styles.brandMuted}>{profile.tagline}</Text> : null}
        {lines.map((line, i) => (
          <Text key={i} style={styles.brandMuted}>{line}</Text>
        ))}
      </View>
    </View>
  );
};

export default InvoiceSellerBlock;
